import { SHOW_HIDE_TOAST, UNREAD_NOTIFICATIONS, ALL_NOTIFICATIONS } from "./type";
import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";

export const showHideToast = (modal, message) => (dispatch) => {
  dispatch({
    type: SHOW_HIDE_TOAST,
    payload: { isToast: modal, toastMessage: message },
  });
};

export const fetchUnreadNotifications = () => async (dispatch) => {
  try {
    const res = await callWebService(
      callTypes.get,
      "",
      Config.notifications.fetchUnread
    );
    if (res) {
      const { data } = res;
      dispatch({ 
        type: UNREAD_NOTIFICATIONS, 
        payload: data.response.data,
      });
      return data.response.data;
    }
  }
  catch {
    dispatch({ 
      type: UNREAD_NOTIFICATIONS, 
      payload: [],
    });
  }
};

export const fetchAllNotifications = () => async (dispatch) => {
  try {
    dispatch({ 
      type: ALL_NOTIFICATIONS, 
      payload: [],
    });
    const res = await callWebService(
      callTypes.get,
      "",
      Config.notifications.fetchAll
    );
    if (res) {
      const { data } = res;
      dispatch({ 
        type: ALL_NOTIFICATIONS, 
        payload: data.response.data,
      });
      return true;
    }
  }
  catch {
    dispatch({ 
      type: ALL_NOTIFICATIONS, 
      payload: [],
    });
  }
};
